<template>
  <li :id="uid" class="horizontal-feature-block">
    <div class="row">
      <div class="hfb-icon-col col-xs-2 col-sm-3">
        <div class="rounded-background center-block">
          <div class="icon-container">
            <svg-icon :icon="icon" color="#fff"/>
          </div>
        </div>
      </div>
      <div class="col-xs-10 col-sm-9">
        <div class="title-container">
          <h5><b v-html="title"></b></h5>
          <p class="text-justify"
             v-for="(t, i) in texts"
             :key="`${uid}-text-${i}`">
            <small v-html="t"></small>
          </p>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
import svgIcon from '@/sui/components/svgIcon'

export default {
  name: 'horizontal-feature-block',
  props: {
    title: String,
    icon: String,
    texts: {
      type: Array,
      default: () => []
    },
    color: String
  },

  computed: {
    uid () {
      return 'horizontal-feature-block-' + this._uid
    }
  },

  components: {
    'svg-icon': svgIcon
  }
}
</script>
<style scoped lang="less">
@import '~modules';
@import '~variables';

li.horizontal-feature-block {
    list-style-type: none;
    line-height: 1.2rem;
    margin-bottom: 1rem;
}

.rounded-background {
    position: relative;
    width: 90%;
    padding-top: 90%;
    height: 0;
    background-color: black;
    border-radius: 50%;
    display: block;
}

.hfb-icon-col {
    padding-left: 1.5%;
    padding-right: 1.5%;
}

.hfb-default .rounded-background {
    background-color: @gray-light;
}

.icon-container {
    position: absolute;
    top: 15%;
    left: 15%;
    bottom: 15%;
    right: 15%;
}
</style>
